import { Link } from "react-router-dom";

const CdeDetailsLink = ({
  associatedCDE,
  reportType,
  crfId,
  domainName,
  subDomainName,
  crfName,
  diseaseId
}) => {
  const handleDetailsClick = (e) => {
    e.preventDefault();

    const newRoute = `ninds/cde-details/${reportType}`;

    const handler = window.open(`${window.location.origin}/${newRoute}`);

    handler.onload = () => {
      handler.postMessage({ message: 'cde-details', diseaseId: diseaseId, crfcdeId: crfId, domain: domainName, subDomain: subDomainName, crfName });
    };
  };

  return (
    <>
      {associatedCDE ? (
        <a href="" onClick={handleDetailsClick}>CDE Details</a>
      ) : (
        "N/A"
      )}
    </>
  );
};

export default CdeDetailsLink;